/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Faq_A6Inputs */

const en_fc_home_faq_a6 = /** @type {(inputs: Fc_Home_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`macOS (Universal: Apple silicon and Intel), Windows 10/11 (x64, ARM64, x86), Linux (x86_64 and ARM64 via AppImage, Flatpak, .deb, .rpm or Arch packages, plus RISC-V), FreeBSD and the browser.`)
};

/**
* | output |
* | --- |
* | "macOS (Universal: Apple silicon and Intel), Windows 10/11 (x64, ARM64, x86), Linux (x86_64 and ARM64 via AppImage, Flatpak, .deb, .rpm or Arch packages, plus..." |
*
* @param {Fc_Home_Faq_A6Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_faq_a6 = /** @type {((inputs?: Fc_Home_Faq_A6Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Faq_A6Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_faq_a6(inputs)
});
export { fc_home_faq_a6 as "fc.home.faq.a6" }